import React from "react";
import "./Slideslan.css";

const roles = [
  { role: "Software Engineer", desc: "Crafting scalable backend systems.", img: "1" },
  { role: "UI/UX Designer", desc: "Designing intuitive user experiences.", img: "2" },
  { role: "Frontend Developer", desc: "Creating responsive web interfaces.", img: "3" },
  { role: "Graphic Designer", desc: "Designing visual storytelling.", img: "4" },
  { role: "DevOps Engineer", desc: "Automating infrastructure and CI/CD.", img: "5" },
  { role: "QA Engineer", desc: "Ensuring quality with rigorous testing.", img: "6" },
  { role: "Product Manager", desc: "Bridging tech and user needs.", img: "7" },
  { role: "Data Scientist", desc: "Unlocking insights from data.", img: "8" }
];

function Slideslan() {
  const leftColumn = roles.filter((_, i) => i % 2 === 0);
  const rightColumn = roles.filter((_, i) => i % 2 !== 0);

  const renderCards = (items) =>
    [...items, ...items].map((item, index) => (
      <div className="hire-role-card" key={index}>
        <div className={`hire-avatar hire-avatar-${item.img}`}></div>
        <div className="hire-role-details">
          <strong className="hire-role-title">{item.role}</strong>
          <p className="hire-role-desc">{item.desc}</p>
        </div>
      </div>
    ));

  return (
    <div className="hire-section-container">
      <div className="hire-text-section">
        <h1 className="hire-heading">
          <span className="hire-highlight">Hire</span> with Confidence,<br />
          Scale with Ease
        </h1>
        <p className="hire-description">
          AI-powered hiring solutions to find the right talent faster and build high-performing teams effortlessly.
        </p>
        <a
          href="https://jobs.skillshap.com/employer/account/signup"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="hire-button">POST FREE JOB</button>
        </a>
      </div>

      <div className="hire-columns">
        <div className="scroll-column scroll-up">
          {renderCards(leftColumn)}
        </div>
        <div className="scroll-column scroll-down">
          {renderCards(rightColumn)}
        </div>
      </div>
    </div>
  );
}

export default Slideslan;
